export abstract class IDeviceInfo {
    public abstract IsMobile(): boolean
    public abstract IsSmartphone(): boolean
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/device/IDeviceInfo.ts